// CIAInfo.js
import React from 'react';

const CIA = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="p-8">
          <h1 className="text-3xl font-bold mb-4 text-blue-600">
            How to Earn the Certified Internal Auditor (CIA) Certification
          </h1>
          <p className="mb-4">
            The CIA certification is a globally recognized credential offered by the Institute of Internal Auditors (IIA). It validates your expertise in internal auditing and can enhance your career. Follow these steps to obtain the certification:
          </p>
          <ol className="list-decimal ml-6 space-y-4">
            <li>
              <strong>Meet Eligibility Requirements:</strong>
              <ul className="list-disc ml-6 mt-2">
                <li>
                  <span className="font-semibold">Education:</span> A bachelor's degree or equivalent is typically required.
                </li>
                <li>
                  <span className="font-semibold">Work Experience:</span> Relevant professional experience in internal auditing or a related field.
                </li>
                <li>
                  <span className="font-semibold">Ethical Standards:</span> Adherence to the IIA’s ethical guidelines.
                </li>
              </ul>
            </li>
            <li>
              <strong>Application Process:</strong>
              <p className="mt-2">
                Submit your application along with the required documentation and fees. Detailed eligibility criteria and instructions are available on the IIA website.
              </p>
            </li>
            <li>
              <strong>Exam Preparation:</strong>
              <p className="mt-2">
                The CIA exam is divided into three parts covering internal audit basics, practice, and business knowledge. Many candidates use study guides, preparatory courses, or study groups.
              </p>
            </li>
            <li>
              <strong>Scheduling and Taking the Exam:</strong>
              <p className="mt-2">
                Once your application is approved, schedule your exam at an authorized testing center or online.
              </p>
            </li>
            <li>
              <strong>Certification and Continuing Education:</strong>
              <p className="mt-2">
                After passing the exam, maintain your certification with ongoing professional education (CPE credits) and adherence to the IIA’s standards.
              </p>
            </li>
          </ol>
          <h2 className="text-2xl font-bold mt-8 mb-4 text-blue-600">References</h2>
          <ul className="list-disc ml-6">
            <li>
              <a 
                className="text-blue-500 hover:underline" 
                href="https://www.theiia.org/en/certifications/cia/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Institute of Internal Auditors (IIA) – Certified Internal Auditor (CIA)
              </a>
            </li>
            <li>
              <a 
                className="text-blue-500 hover:underline" 
                href="https://www.gleim.com/cia-review/" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Gleim CIA Review – Exam Prep Resources
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CIA;
